// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"944b15ac","239":"bb1e2b45","667":"b6db34e1","867":"8be32538"}[chunkId] + ".chunk.js";
};